<template>
    <div class="experience mb-5">
        <div class="m-auto text-left control-width border shadow add-rounded p-4">
                <h5 class="mt-4 font-weight-bold kova-text mb-2"> Years of Office Work Experience</h5>
                <span class="font-weight-bold"><a-input-number class="ml-2 w-50" size="large" :min="0" :max="10" placeholder="0"/></span><br />
                <div :key="n" v-for="n in numLinkFrontEnd">
                    <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
                </div>


                <h5 class="font-weight-bold kova-text mt-3 mb-2">Number of Remote project completed?</h5>
                <span class="font-weight-bold"><a-input-number class="ml-2 w-50" size="large" :min="0" :max="10" placeholder="0" @change="displayLinkBack"/></span><br />
                <div :key="n" v-for="n in numLinkBackEnd">
                    <a-input class="mt-3 w-75" addonBefore="https://" placeholder="add project link" /><br/>
               </div>

            <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                    </div>
                    <div class="col text-right">
                         <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                    </div>
                </div>
            </div>
            
        </div>
        
 </div>
</template>
<script>

export default {
    name: 'stack',
    data(){
        return {
            speciality:'',
            showForFrontEnd: false,
            showForBackEnd: false,
            showForOther: false,
            numLinkFrontEnd: 0,
            numLinkBackEnd: 0,
            numLinkOthers: 0,
        }
    },
    watch: {
        speciality: function(){
            if(this.speciality == 'Front-end'){
                this.showForOther = false;
                this.showForBackEnd = false;
                return this.showForFrontEnd = true;
            }
            else if(this.speciality == 'Back-end'){
                this.showForOther = false;
                this.showForFrontEnd = false;
                return this.showForBackEnd = true;
            }
            else if (this.speciality == 'Full Stack'){
                this.showForOther = false;
                return this.showForFrontEnd = true, this.showForBackEnd = true;
            }else{
                this.showForOther = true;
                return this.showForFrontEnd = false, this.showForBackEnd = false
            }
        },
    },
    methods: {
        goBack(){
            this.$router.go(-1);
        },
        next(){
            this.$router.push('devs');
        },
        displayLink(value){
            this.numLinkFrontEnd = value;
        },
        displayLinkBack(value){
            this.numLinkBackEnd = value;
        },
        displayLinkOthers(value){
            this.numLinkOthers = value;
        }
    }
}
</script>
<style scoped>

.input{
    width: 90%;
    height: 50px;
    outline: 0;
    border: solid 1px #20409a;
    border-radius: 5px;
}
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>